import {
  AssignmentCard,
  CardstackAssignmentCard,
  DesmosAssignmentCard,
} from 'entities/assignments';
import { TaughtLessonCard } from 'entities/taught-lessons';
import { useClassData } from 'entities/classes';
import { generateCardEventHandlers } from 'shared/api/event-service';
import { Assignment } from 'shared/api/assignment-service';
import { TaughtLesson } from 'shared/api/class-stats';

export type StreamContentProps = {
  items: (Assignment | TaughtLesson)[] | null;
};

export const StreamContent = ({ items }: StreamContentProps) => {
  const { classData } = useClassData();

  const getCardLabel = (classBk: string | string[]): string => {
    if (Array.isArray(classBk)) {
      return classData?.[classBk[0]]?.displayName ?? '';
    }
    return classData?.[classBk]?.displayName ?? '';
  };

  const getClassGrades = (classBk: string | string[]) => {
    if (Array.isArray(classBk)) {
      return classData?.[classBk[0]]?.grades ?? [];
    }

    return classData?.[classBk]?.grades ?? [];
  };

  return (
    <>
      {items?.map((item) => {
        const itemClassBk =
          item.type === 'TaughtLesson' ? item.classBk : item.classBks;

        const currentClassGrades = getClassGrades(itemClassBk);
        const currentClassLabel = getCardLabel(itemClassBk);

        if (item.type === 'Lesson') {
          return (
            <AssignmentCard
              key={item.businessKey}
              classLabel={currentClassLabel}
              assignment={item}
              eventHandlers={generateCardEventHandlers({
                currentClassGrades,
                item,
              })}
            />
          );
        }
        if (item.type === 'Cardstack') {
          return (
            <CardstackAssignmentCard
              key={item.businessKey}
              classLabel={currentClassLabel}
              assignment={item}
              eventHandlers={generateCardEventHandlers({
                currentClassGrades,
                item,
              })}
            />
          );
        }
        if (item.type === 'desmos') {
          return (
            <DesmosAssignmentCard
              key={item.businessKey}
              classLabel={currentClassLabel}
              assignment={item}
              eventHandlers={generateCardEventHandlers({
                currentClassGrades,
                item,
              })}
            />
          );
        }
        return (
          <TaughtLessonCard
            key={item.id}
            classLabel={currentClassLabel}
            lesson={item}
            eventHandlers={generateCardEventHandlers({
              currentClassGrades,
              item,
            })}
          />
        );
      })}
    </>
  );
};
